import * as _ from 'underscore';
import 'bxslider/dist/jquery.bxslider.min';

let sliders = {};

export default function (el, htmlOptions) {
    let settings = {},
        // The default settings
        defaultSettings = {
            pager: false,
            controls: false,
            preloadImages: 'visible',
            infiniteLoop: true,
            touchEnabled: false,
            keyboardEnabled: true,
            onSliderLoad: function ($slideElement, $oldIndex, $newIndex) {
                if (typeof (settings['linkto']) !== "undefined") {

                    let $thumbnails = $('#' + settings['id']).find('a');

                    // Click on thumbnail -> link thumbnails to slideshow
                    $thumbnails.on('click', function (e) {
                        e.preventDefault();

                        let id = $(this).data('id');

                        // Remove active state for any thumbnail
                        $thumbnails.removeClass('active');

                        // Add active state for clicked thumbnail
                        $(this).addClass('active');

                        if (sliders[settings['linkto']]) {
                            // Go to corresponding slide in slideshow
                            sliders[settings['linkto']].goToSlide($(this).data("slide-index"));

                            // If video galerie -> stop all youtube players on thumbnail click in slideshow
                            $(sliders[settings['linkto']]).find('.elasticIframeWrapper__iframeWrapper iframe').each(function () {
                                //var iframe = document.getElementById('iframe-' + id);
                                this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                            });
                        }
                    });
                }
            }
        };

    // Convert boolean settings from HTML
    // data attributes to real boolean values
    _.each(htmlOptions, function (value, key, list) {
        if (value === 'false') {
            settings[key] = false;
        }
        if (value === 'true') {
            settings[key] = true;
        }

        // Convert number values from HTML
        // data attributes to real numbers
        if ($.inArray(key, ['slideMargin', 'slideWidth', 'minSlides', 'maxSlides', 'moveSlides']) !== -1)
            settings[key] = parseInt(value);
    });

    // Extend the default settings with HTML data settings
    settings = $.extend(true, {}, defaultSettings, htmlOptions, settings);

    // Create slider and put into sliders collection object
    sliders[settings['id']] = $('#' + settings['id']).bxSlider(settings);

    document.addEventListener('reloadSlider', function (e) {
      _.each(e.detail.sliderIds, (id) => {
        sliders[id].reloadSlider();
      });
    });
};
